import React, { FC } from 'react';

import { ForgeUIExtensionsWrapper } from '../components/ForgeUIExtensionsWrapper/ForgeUIExtensionsWrapper';
import { ForgeExtensionPointAppsListType } from '../types';

export const ForgeExtensionPointAppsList: FC<
  ForgeExtensionPointAppsListType
> = ({ AppsListComponent, currentUser, moduleType, workspace }) => (
  <ForgeUIExtensionsWrapper
    currentUser={currentUser}
    moduleType={moduleType}
    render={extensions =>
      extensions.map(app => <AppsListComponent key={app.id} app={app} />)
    }
    workspace={workspace}
  />
);
